import * as actions from 'appRedux/actions/insight/insightActionType';

export interface InsightState {
  loaderPickup: boolean;
  loaderPace: boolean;
  loaderProductivity: boolean;
  pickupData: any[];
  paceData: any;
  productivityData: any[] | null;
  process: { status: boolean; action: string; message: string };
}

const initialState: InsightState = {
  loaderPickup: false,
  loaderPace: false,
  loaderProductivity: false,
  pickupData: [],
  paceData: null,
  productivityData: null,
  process: { status: false, action: '', message: '' },
};

export default (state: InsightState = initialState, action: actions.InsightAction): InsightState => {
  switch (action.type) {
    case actions.INSIGHT_RESERVATION_PICKUP_REQUEST:
      return { ...state, loaderPickup: true, process: { status: false, action: '', message: '' } };
    case actions.INSIGHT_RESERVATION_PICKUP_SUCCESS:
      return { ...state, loaderPickup: false, pickupData: action.payload };
    case actions.INSIGHT_BOOKING_PACE_REQUEST:
      return { ...state, loaderPace: true, process: { status: false, action: '', message: '' } };
    case actions.INSIGHT_BOOKING_PACE_SUCCESS:
      return { ...state, loaderPace: false, paceData: action.payload };
    case actions.INSIGHT_PRODUCTIVITY_REQUEST:
      return { ...state, loaderProductivity: true, productivityData: [], process: { status: false, action: '', message: '' } };
    case actions.INSIGHT_PRODUCTIVITY_SUCCESS:
      return { ...state, loaderProductivity: false, productivityData: Array.isArray(action.payload) ? action.payload : [] };
    case actions.INSIGHT_PROCESS_SUCCESS:
      return { ...state, loaderPickup: false, loaderPace: false, loaderProductivity: false, process: action.payload };
    case actions.INSIGHT_PROCESS_RESET:
      return { ...state, process: { status: false, action: '', message: '' } };
    default:
      return state;
  }
};
